export const EXPANDING_DURATION_MS = 300;
export const EXPANDING_ANIMATION = 'ease-in-out';
